module.exports = __webpack_public_path__ + "static/media/check-double.6706d3fd.svg";